import Breadcrumb from '@/components/common/Breadcrumb';
import Footer from '@/components/layout/Footer';
import Navbar from '@/components/layout/menu-bar/Navbar';
import Sidebar from '@/components/layout/menu-bar/Sidebar';
import { useStore } from '@/hooks/useStore';
import { getBreadcrumb, getTitlePage } from '@/utils/routes';
import { cn } from '@/utils/utils';
import { observer } from 'mobx-react-lite';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Outlet, useLocation } from 'react-router-dom';

export default observer(function AdminPanelLayout() {
    // hooks
    const { t } = useTranslation();
    const { pathname } = useLocation();

    // variables
    const { title }: any = getTitlePage(pathname);
    const breadcrumb = getBreadcrumb(pathname);

    // store
    const {
        uiStore: { isOpenSidebar },
        authStore: { getProfile }
    } = useStore();

    // lifecycle
    useEffect(() => {
        // getProfile();
    }, [pathname]);

    return (
        <>
            <Sidebar />
            <main
                className={cn(
                    'min-h-[calc(100vh_-_56px)] bg-background-4 transition-[margin-left] ease-in-out duration-300',
                    isOpenSidebar === false ? 'lg:ml-[90px]' : 'lg:ml-72'
                )}
            >
                <Navbar title={title} />
                <div className='p-2 md:py-6 md:px-8'>
                    <div className='hidden md:flex md:justify-between md:items-center h-[44px]'>
                        <h1 className='title-page mb-6'>{t(title)}</h1>
                    </div>
                    <div className='text-card-foreground rounded-lg border-none min-h-[calc(100vh-56px-64px-20px-24px-56px)]'>
                        <Outlet />
                    </div>
                </div>
            </main>
            {/* <footer
                className={cn(
                    'transition-[margin-left] ease-in-out duration-300',
                    isOpenSidebar === false ? 'lg:ml-[90px]' : 'lg:ml-72'
                )}
            >
                <Footer />
            </footer> */}
        </>
    );
});
